(function () {
  function closeVideo(dialog) {
    if (!dialog) return;
    var frame = dialog.querySelector('iframe');
    if (frame) frame.src = '';
    if (typeof dialog.close === 'function') dialog.close();
    else dialog.removeAttribute('open');
  }

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-mm-video-open]');
    if (trigger) {
      var dialog = document.getElementById(trigger.getAttribute('aria-controls'));
      var frame = dialog && dialog.querySelector('iframe');
      var id = trigger.getAttribute('data-mm-video-id');
      var type = trigger.getAttribute('data-mm-video-type');
      if (!dialog || !frame || !id) return;
      frame.src = type === 'vimeo'
        ? 'https://player.vimeo.com/video/' + id + '?autoplay=1&dnt=1'
        : 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0';
      if (typeof dialog.showModal === 'function') dialog.showModal();
      else dialog.setAttribute('open', '');
    }

    var close = event.target.closest('[data-mm-video-close]');
    if (close) closeVideo(close.closest('dialog'));
  });

  document.addEventListener('cancel', function (event) {
    if (event.target.matches('.mm-video-dialog')) closeVideo(event.target);
  });

  document.addEventListener('click', function (event) {
    if (event.target.matches('.mm-video-dialog')) closeVideo(event.target);
  });
})();

/* v18 — Symbiotic guided discovery
   Remembers only an explicit choice, only for the current browser tab. */
(function () {
  var storageKey = 'mmSymbioticIntent';

  function readIntent() {
    try { return window.sessionStorage.getItem(storageKey); }
    catch (error) { return null; }
  }

  function writeIntent(value) {
    try { window.sessionStorage.setItem(storageKey, value); }
    catch (error) { /* The guide still works when storage is unavailable. */ }
  }

  function clearIntent() {
    try { window.sessionStorage.removeItem(storageKey); }
    catch (error) { /* The guide still works when storage is unavailable. */ }
  }

  function exposeIntent(value) {
    if (value) document.documentElement.setAttribute('data-mm-intent', value);
    else document.documentElement.removeAttribute('data-mm-intent');
  }

  function initGuide(root) {
    if (!root || root.getAttribute('data-mm-symbiotic-ready') === 'true') return;

    var choices = root.querySelectorAll('[data-mm-symbiotic-choice]');
    var panels = root.querySelectorAll('[data-mm-symbiotic-result]');
    var resets = root.querySelectorAll('[data-mm-symbiotic-reset]');
    var status = root.querySelector('[data-mm-symbiotic-status]');
    var validIntents = {};

    Array.prototype.forEach.call(choices, function (choice) {
      validIntents[choice.getAttribute('data-mm-symbiotic-choice')] = true;
    });

    function selectIntent(value, persist, announce) {
      if (!validIntents[value]) return false;

      Array.prototype.forEach.call(choices, function (choice) {
        var selected = choice.getAttribute('data-mm-symbiotic-choice') === value;
        choice.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });

      Array.prototype.forEach.call(panels, function (panel) {
        panel.hidden = panel.getAttribute('data-mm-symbiotic-result') !== value;
      });

      var activeChoice = root.querySelector('[data-mm-symbiotic-choice="' + value + '"]');
      if (announce && status && activeChoice) {
        status.textContent = activeChoice.getAttribute('data-mm-symbiotic-status') || '';
      }

      root.classList.add('is-selected');
      exposeIntent(value);
      if (persist) writeIntent(value);

      try {
        document.dispatchEvent(new CustomEvent('mama:symbiotic-intent-change', {
          detail: { intent: value, surface: root.getAttribute('data-mm-symbiotic-surface') }
        }));
      } catch (error) { /* Custom events are an optional enhancement. */ }

      return true;
    }

    function resetGuide() {
      Array.prototype.forEach.call(choices, function (choice) {
        choice.setAttribute('aria-pressed', 'false');
      });
      Array.prototype.forEach.call(panels, function (panel) { panel.hidden = true; });

      root.classList.remove('is-selected');
      exposeIntent(null);
      clearIntent();
      if (status) status.textContent = root.getAttribute('data-mm-symbiotic-reset-status') || '';
      if (choices.length) choices[0].focus();
    }

    Array.prototype.forEach.call(choices, function (choice) {
      choice.addEventListener('click', function () {
        selectIntent(choice.getAttribute('data-mm-symbiotic-choice'), true, true);
      });
    });

    Array.prototype.forEach.call(resets, function (reset) {
      reset.addEventListener('click', resetGuide);
    });

    root.setAttribute('data-mm-symbiotic-ready', 'true');
    var rememberedIntent = readIntent();
    if (rememberedIntent) selectIntent(rememberedIntent, false, false);
  }

  function initGuides(scope) {
    var context = scope && scope.querySelectorAll ? scope : document;
    if (context.matches && context.matches('[data-mm-symbiotic-guide]')) initGuide(context);
    Array.prototype.forEach.call(context.querySelectorAll('[data-mm-symbiotic-guide]'), initGuide);
  }

  function start() { initGuides(document); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();

  document.addEventListener('shopify:section:load', function (event) {
    initGuides(event.target);
  });
})();

/* v18 — Persistent mobile navigation + contextual back.
   The header is intentionally sticky: no directional auto-hide. */
(function () {
  var cleanupMenu = null;
  function initMenu() {
  if (cleanupMenu) cleanupMenu();
  var header = document.querySelector('.main-header[data-header]');
  var menu = header && header.querySelector('.mm-mobile-menu');
  if (!header || !menu) return;

  function syncMenuState() {
    var open = menu.open;
    header.classList.toggle('menu-open', open);
    document.body.classList.toggle('mm-nav-open', open);
    header.classList.remove('out-of-view');
  }

  menu.addEventListener('toggle', syncMenuState);
  syncMenuState();

  function onMenuKeydown(event) {
    if (event.key === 'Escape' && menu.open) {
      menu.open = false;
      var summary = menu.querySelector(':scope > summary');
      if (summary) summary.focus();
    }
  }

  function onMenuResize() {
    header.classList.remove('out-of-view');
    if (window.matchMedia('(min-width: 961px)').matches && menu.open) menu.open = false;
    if (!menu.open) document.body.classList.remove('mm-nav-open');
  }
  document.addEventListener('keydown', onMenuKeydown);
  window.addEventListener('resize', onMenuResize, { passive: true });
  cleanupMenu = function () {
    menu.removeEventListener('toggle', syncMenuState);
    document.removeEventListener('keydown', onMenuKeydown);
    window.removeEventListener('resize', onMenuResize);
    document.body.classList.remove('mm-nav-open');
  };
  }
  initMenu();
  document.addEventListener('shopify:section:load', initMenu);
})();

(function () {
  document.addEventListener('click', function (event) {
    var back = event.target.closest && event.target.closest('[data-mm-smart-back]');
    if (!back) return;

    try {
      if (!document.referrer) return;
      var previous = new URL(document.referrer, window.location.href);
      var current = new URL(window.location.href);
      if (previous.origin !== current.origin) return;
      if (previous.pathname === current.pathname && previous.search === current.search) return;

      event.preventDefault();
      window.history.back();
    } catch (error) {
      /* Keep the server-rendered fallback href when history is unavailable. */
    }
  });
})();

/* v17.1 — Keep the legacy Slick gallery stable without relying on a global
   jQuery object. The base theme runs jQuery in no-conflict mode, so code that
   checks window.jQuery never executes on the storefront. */
(function () {
  if (!document.body.classList.contains('template-product')) return;

  var frame = null;
  var galleryObserver = null;

  function getGallery() {
    return document.querySelector('[data-product-images]');
  }

  function syncProductGalleryA11y(gallery) {
    if (!gallery) return;

    var slides = Array.prototype.filter.call(
      gallery.querySelectorAll('.product-media-item'),
      function (slide) { return !slide.classList.contains('slick-cloned'); }
    );
    var active = gallery.querySelector('.product-media-item.slick-current') ||
      gallery.querySelector('.product-media-item.slick-active') ||
      gallery.querySelector('.product-media-item.product-single__media--selected');
    var activeId = active && active.getAttribute('data-media-id');
    var currentSlide = 0;

    slides.forEach(function (slide, index) {
      var isCurrent = activeId
        ? slide.getAttribute('data-media-id') === activeId
        : index === 0;
      slide.setAttribute('aria-hidden', isCurrent ? 'false' : 'true');
      if (isCurrent) currentSlide = index;
    });

    document.querySelectorAll('.product-thumbnail-wrap').forEach(function (thumbnail, index) {
      if (index === currentSlide) thumbnail.setAttribute('aria-current', 'true');
      else thumbnail.removeAttribute('aria-current');
    });
  }

  function nudgeSlickLayout(gallery) {
    if (!gallery || !gallery.classList.contains('slick-initialized')) return;
    if (!Math.round(gallery.getBoundingClientRect().width)) return;

    /* Slick owns a private jQuery reference and listens to native window
       resize. Dispatching that event asks the existing instance to recalculate
       widths without reaching into its private runtime. */
    window.dispatchEvent(new Event('resize'));
    syncProductGalleryA11y(gallery);
    window.setTimeout(function () { syncProductGalleryA11y(gallery); }, 100);
  }

  function scheduleGalleryLayout(delay) {
    window.setTimeout(function () {
      var gallery = getGallery();
      if (!gallery) return;
      if (frame) window.cancelAnimationFrame(frame);
      frame = window.requestAnimationFrame(function () {
        nudgeSlickLayout(gallery);
      });
    }, delay || 0);
  }

  function observeGallery() {
    var gallery = getGallery();
    if (!gallery) return;

    if (galleryObserver) galleryObserver.disconnect();
    if ('MutationObserver' in window) {
      galleryObserver = new MutationObserver(function () {
        syncProductGalleryA11y(gallery);
      });
      galleryObserver.observe(gallery, {
        subtree: true,
        attributes: true,
        attributeFilter: ['class']
      });
    }

    gallery.addEventListener('load', function () {
      scheduleGalleryLayout(0);
    }, true);
    syncProductGalleryA11y(gallery);
  }

  observeGallery();

  window.addEventListener('load', function () {
    scheduleGalleryLayout(0);
    scheduleGalleryLayout(240);
  }, { once: true });

  window.addEventListener('orientationchange', function () {
    scheduleGalleryLayout(140);
  });

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target && event.target.querySelector && event.target.querySelector('[data-product-images]')) {
      window.setTimeout(function () {
        observeGallery();
        scheduleGalleryLayout(0);
      }, 120);
    }
  });
})();

/* v8.5.5 — Global Liquid Glass scroll-to-top. */
(function () {
  var button = document.querySelector('[data-mm-scroll-top]');
  if (!button) return;

  var visible = false;
  var ticking = false;
  var threshold = Math.max(520, Math.round(window.innerHeight * 0.72));

  function setVisible(nextVisible) {
    if (nextVisible === visible) return;
    visible = nextVisible;
    button.hidden = false;
    button.classList.toggle('is-visible', visible);
    button.setAttribute('aria-hidden', visible ? 'false' : 'true');
    button.tabIndex = visible ? 0 : -1;
  }

  function update() {
    ticking = false;
    setVisible(window.scrollY > threshold);
  }

  function requestUpdate() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(update);
  }

  button.hidden = false;
  button.setAttribute('aria-hidden', 'true');
  button.tabIndex = -1;
  update();

  window.addEventListener('scroll', requestUpdate, { passive: true });
  window.addEventListener('resize', function () {
    threshold = Math.max(520, Math.round(window.innerHeight * 0.72));
    requestUpdate();
  }, { passive: true });

  button.addEventListener('click', function () {
    var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: 0, behavior: reducedMotion ? 'auto' : 'smooth' });
  });
})();
